var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ELevelResult } from 'Shared/types';
import { LEVEL_RESULT_NAME } from 'Common/consts';
export const availableLevelResults = {
    [LEVEL_RESULT_NAME[ELevelResult.Gene]]: true,
    [LEVEL_RESULT_NAME[ELevelResult.Variant]]: FEATURE_FLAGS.VLR_TAB_ENABLED,
    [LEVEL_RESULT_NAME[ELevelResult.Phenotype]]: FEATURE_FLAGS.PLR_TAB_ENABLED,
};
/**
 * Creates an error message for level results tabs if empty data received
 *
 * @param levelResult - Current's tab level result
 * @returns - Error message in string format
 */
export const getErrorMessage = (levelResult, commonError) => {
    const _a = LEVEL_RESULT_NAME, _b = levelResult, currentLevelResult = _a[_b], args = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    const anotherLevelResults = Object.values(args)
        .filter((anotherLevelResult) => availableLevelResults[anotherLevelResult])
        .join(' or ');
    if (anotherLevelResults.length === 0 || commonError) {
        return `${currentLevelResult} are not available for this dataset. Please switch to another dataset.`;
    }
    return `${currentLevelResult} are not available for this dataset. Please see ${anotherLevelResults} or switch to another dataset.`;
};
